@layer ch-grid {
  ch-grid-columnset {
    display: contents;
  }
}
@layer ch-grid {
  ch-grid-row {
    display: contents;
  }

  ch-grid-row[collapsed] > ch-grid-rowset {
    display: none;
  }

  ch-grid-row:is([leaf="false"], :has(> ch-grid-rowset)) > ch-grid-cell::part(caret) {
    visibility: visible;
  }

  ch-grid-row[dragging] {
    display: flex;
    position: fixed;
    pointer-events: none;
    box-shadow: rgba(0, 0, 0, 0.7) 0px 5px 15px;
    z-index: 1000;
    transition: top var(--row-drag-transition-duration, 0.1s);
  }
}
@layer ch-grid {
  ch-grid-rowset {
    display: contents;
  }

  ch-grid-rowset[collapsed] > :not(ch-grid-rowset-legend) {
    display: none;
  }
}
@layer ch-grid {
  ch-grid-cell {
    position: sticky;
    grid-column: var(--grid-column);
    transition: transform var(--column-drag-transition-duration, 0.2s);
  }

  ch-grid-cell[selected] {
    --ch-grid-cell-z-index-active: var(--ch-grid-cell-active-layer);
  }

  ch-grid-cell,
ch-grid-row[selected] > ch-grid-cell,
ch-grid-row[highlighted] > ch-grid-cell {
    background-color: inherit;
    margin-block-start: inherit;
    margin-block-end: inherit;
    border-block-start: inherit;
    border-block-end: inherit;
    padding-block-start: inherit;
    padding-block-end: inherit;
  }

  ch-grid-cell:before {
    margin-inline-start: calc(var(--indent) * var(--level));
  }

  ch-grid-cell::part(indent) {
    width: calc(var(--indent) * var(--level));
  }

  ch-grid-cell::part(caret) {
    visibility: hidden;
  }
}